<!-- Dynamic menu items rendered from tabs configuration -->
@for (p of tabs(); track $index) {
<ng-container>
  <ion-menu-toggle persistent="true" auto-hide="false">
    <!-- Exclude specific menu item based on title -->
    @if (p.title !== 'DKV charge+') {
    <ion-item class="menu-item" lines="none" detail="false" [id]="p.id"
      [routerLink]="p.url" routerDirection="root"
      [disabled]="disabled()"
      [attr.aria-disabled]="disabled() ? 'true' : 'false'"
      [ngClass]="{'menu-item-disabled': disabled()}"
      routerLinkActive="active" [routerLinkActiveOptions]="{ exact: true }">
      <!-- Menu icon -->
      <ion-icon class="svgIcon" size="large" [src]="p.icon">
      </ion-icon>

      <!-- Menu label rendered for English language -->
      @if (language() === 'en') {
      <ion-label class="menu-labels">
        {{ p.name }}
      </ion-label>
      }
    </ion-item>
    }
  </ion-menu-toggle>
</ng-container>
}

<!-- Logout action pinned at the bottom of the menu -->
<ng-container>
  <ion-menu-toggle persistent="true" auto-hide="false">
    <ion-item class="menu-item" lines="none" detail="false" routerDirection="root"
      [disabled]="disabled()"
      [attr.aria-disabled]="disabled() ? 'true' : 'false'"
      [ngClass]="{'menu-item-disabled': disabled()}"
      (click)="logout()"
      (keydown.enter)="logout()">
      <!-- Logout icon -->
      <ion-icon class="svgIcon" size="large" src="assets/imgs/logout-icon.svg">
      </ion-icon>

      <!-- Logout label -->
      <ion-label class="menu-labels">
        Logout
      </ion-label>
    </ion-item>
  </ion-menu-toggle>
</ng-container>